import {
  FETCH_MENTOR_REQUEST,
  FETCH_MENTOR_SUCCESS,
  FETCH_MENTOR_FAILURE,
} from './actions';
import { Map } from 'immutable';
import Mentor from './model';
import { ApiResponseHelper } from 'omni-common-ui';

export default function mentor(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_MENTOR_REQUEST:
      return ApiResponseHelper.create({ loading: true });
    case FETCH_MENTOR_SUCCESS:
      return onSuccess(state, action);
    case FETCH_MENTOR_FAILURE:
      return ApiResponseHelper.create(action.error);
    default:
      return state;
  }
}

function onSuccess(state, action) {
  let newState = new Map();
  action.payload.forEach((unit) => {
    unit.studentMentorResults.forEach((mentorResult) => {
      const mentorModel = Mentor.create(Object.assign(mentorResult,
        { unitId: unit.unitId, groupId: action.groupId }));
      newState = newState.set(`${action.groupId}-${unit.unitId}-${mentorResult.studentId}`, mentorModel);
    });
  });
  return ApiResponseHelper.create({ data: newState });
}



// WEBPACK FOOTER //
// ./data/Mentor/reducer.js